(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-mobile-menu"] && !Shopify.designMode) return;
  try {
    if (!document.documentElement.hasAttribute('data-jg-mobile-parent-nav')) {
  document.documentElement.setAttribute('data-jg-mobile-parent-nav', 'true');
  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('summary.jg-mobile-parent__toggle');
    if (!toggle) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const parent = toggle.parentElement;
    if (parent && parent.tagName === 'DETAILS') {
      const shouldOpen = !parent.open;
      const applyState = () => { parent.open = shouldOpen; };
      applyState();
      window.setTimeout(applyState, 60);
      window.setTimeout(applyState, 220);
    }
  }, true);
}
  } catch(e) { console.error(e); }
})();

})();
